import { DeliveryMode } from "api/resources/learningItems/types"
import { useMemo } from "react"
import { Controller, useFormContext } from "react-hook-form"

import AgreementCheckBox from "../AgreementCheckBox"
import { currentStepTitle, OnboardingStepId } from "../constants"
import IFrame from "../IFrame"
import SignatureField from "../SignatureField"
import { getAgreementURL } from "../utils"

const LearnersAgreement = ({
  deliveryMode,
  onLoaded,
}: {
  deliveryMode?: DeliveryMode | null
  onLoaded: () => void
}) => {
  const form = useFormContext()

  const url = useMemo(() => {
    const url = new URL(getAgreementURL({ type: "pgctl", deliveryMode }))
    url.searchParams.set("embed", "true")
    return url.toString()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="relative h-auto min-h-full">
      <IFrame
        id="enrollment-agreement-iframe"
        url={url}
        onLoaded={onLoaded}
        render={({ isLoading }) => {
          if (!isLoading) {
            return (
              <div className="mt-3 flex flex-col gap-2">
                <SignatureField />
                <Controller
                  key="learnerAgreement"
                  control={form.control}
                  name="learnerAgreement"
                  render={({ field, fieldState: { error } }) => (
                    <AgreementCheckBox
                      onChange={field.onChange}
                      ref={field.ref}
                      value={field.value}
                      errorMessage={error?.message}
                      title={`I have read and agree to the ${
                        currentStepTitle[OnboardingStepId.learnersAgreement]
                      }`}
                    />
                  )}
                />
              </div>
            )
          }
          return null
        }}
      />
    </div>
  )
}

export default LearnersAgreement
